'use client'

import { motion } from 'framer-motion'
import type { ReactNode } from 'react'

// The code-studio hot-reload preview runs `next dev`, where these scroll-entrance
// animations (whileInView + React Strict Mode double-render) can get stuck and
// leave whole sections invisible ("grey"). In that preview only
// (NEXT_PUBLIC_PREVIEW=1) render content with no entrance animation, so every
// section is faithfully visible. Production keeps the animation.
const PREVIEW = process.env.NEXT_PUBLIC_PREVIEW === '1'

export function FadeIn({
  children,
  delay = 0,
  className,
}: {
  children: ReactNode
  delay?: number
  className?: string
}) {
  if (PREVIEW) {
    return <div className={className}>{children}</div>
  }
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-80px' }}
      transition={{ duration: 0.5, delay, ease: 'easeOut' }}
    >
      {children}
    </motion.div>
  )
}
